import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Utils } from '@serasa/shared/utils/utils';
import { SidenavManagerService } from '../../../../../shared/services/sidenav.manager.service';
import { loadToggleSidenav } from '../../../users/state/actions/user.actions';

@Component({
    selector: 'pl-alert-recertification',
    template: `
    @if (!hasClosed && status !== 'EXPIRED') {
      <pl-alert
        (hasClosed)="closeAlert()"
        display="inline"
        color="warning"
        [close]="close"
        >
        <span header>Atenção</span>
        @if (daysLeft > 0) {
          <span content
            >Sua certificação como {{ userProfile }} desse contrato expirará em
            <b>{{ daysLeft }} dia(s)</b>.
            <a (click)="openSideModal()">Renove sua certificação aqui</a>
          </span>
        }
        @if (daysLeft <= 0) {
          <span content
            >Sua certificação como {{ userProfile }} desse contrato expirará hoje.
            <a (click)="openSideModal()"
              >Renove sua certificação aqui</a
              >
            </span>
          }
        </pl-alert>
      }
      @if (!hasClosed && status === 'EXPIRED') {
        <pl-alert
          (hasClosed)="closeAlert()"
          color="warning"
          display="inline"
          [close]="close"
          >
          <span header>Atenção</span>
          <span content
            >Sua certificação como {{ userProfile }} desse contrato
            <b>expirou dia {{ limitDate | date : 'dd/MM/yyyy' }}</b
              >. Seu acesso pode ser bloqueado a qualquer momento.
              <a (click)="openSideModal()">Renove sua certificação aqui</a>
            </span>
          </pl-alert>
        }
    `,
    styles: [
        `
      span > a {
        font-size: 14px !important;
        text-decoration: underline !important;
        line-height: 1.5rem !important;
        font-weight: 400 !important;
        font-family: Roboto, Helvetica Neue, Arial, 'sans-serif' !important;
        letter-spacing: normal !important;
        color: #1d4f91 !important;
        cursor: pointer;
      }
    `,
    ],
    standalone: false
})
export class AlertRecertificationComponent implements OnInit {
  @Input() daysLeft: any;
  @Input() limitDate: any;
  @Input() close?: boolean;
  @Input() status?: string;

  public hasClosed = false;
  public userProfile = '';

  constructor(
    private readonly store: Store,
    private readonly _sidenavManagerService: SidenavManagerService
  ) {}

  ngOnInit(): void {
    this._verifyUserProfile();
  }

  public openSideModal() {
    this._openSidenav();
    this._sidenavManagerService.navigate$.next('recertification');
  }

  public closeAlert() {
    this.hasClosed = true;
  }

  private _openSidenav() {
    this.store.dispatch(
      loadToggleSidenav({
        openSidenav: true,
      })
    );
  }

  private _verifyUserProfile(): void {
    this.userProfile = Utils.verifyUserProfile();
  }
}
